function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      fill="currentColor"
    >
      <path d="M26 25v3h4V14l-2-2h2v-2h-3l-3-5C22.5 3.5 7.5 3.5 6 5l-3 5H0v2h2l-2 2v14h4v-3h22ZM8 17H2v-2h6v2Zm20 0h-6v-2h6v2Zm-13.11 5c-1.05 0-1.89-.86-1.89-1.92s.85-1.92 1.89-1.92 1.89.86 1.89 1.92S15.93 22 14.89 22ZM16 16v1h-2v-3h2a3 3 0 1 0-3-3v1h-2v-1a5 5 0 1 1 5 5Z" />
    </svg>
  );
}

export default Icon;
